import { Box, Grid } from '@mui/material'
import { useCallback } from 'react'
import { Navigate, useParams } from 'react-router-dom'

import { message } from 'antd'
import { ContentWrapper } from '../../../../../../components/ContentWrapper'
import Helmet from '../../../../../../components/Helmet'
import HeaderContent from '../../../../../../components/Layouts/HeaderContent'
import PageUrls from '../../../../../../constants/page-urls'
import useAxios from '../../../../../../hooks/useAxios'
import { ILead } from '../../../../../../types/lead'
import LeadAddressDetailCard from './components/LeadAddressDetailCard'
import LeadCustomerTrackingNotificationListDetailCard from './components/LeadCustomerTrackingNotificationListDetailCard'
import LeadDetailCard from './components/LeadDetailCard'
import LeadOrderHistoryDetailCard from './components/LeadOrderHistoryDetailCard'
import dayjs from 'dayjs'

const Menus = [
  {
    breadcrumbName: 'รายการติดตามทั้งหมด',
    title: 'รายการติดตามทั้งหมด',
    path: PageUrls.CRM.Lead.List,
  },
]

const LeadDetailPage = () => {
  const { objectId } = useParams()

  const lead = useAxios<ILead>({
    method: 'GET',
    url: `/lead/${objectId}`,
  })

  const onUpdateLeadSuccess = useCallback(async () => {
    try {
      await lead.mutate()
    } catch (error) {
      message.error('ไม่สามารถดึงข้อมูล Lead ได้')
    }
  }, [objectId])

  if (!lead.data && !lead.isLoading) {
    //redir to list
    return <Navigate to={PageUrls.Home} replace />
  }

  const expiredAt = lead.data?.expiredAt ?? ''
  const finished = lead.data?.isFinished ?? false

  const isFinished = dayjs(expiredAt).unix() < dayjs().unix() || finished

  return (
    <ContentWrapper>
      <Helmet title="ข้อมูล Lead" />
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="ข้อมูล Lead"
            routes={Menus}
            descriptions="ข้อมูล Lead"
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={7}>
          <Box mb={2}>
            <LeadOrderHistoryDetailCard
              isLoading={lead?.isLoading}
              data={lead?.data}
              onUpdateLeadSuccess={onUpdateLeadSuccess}
              isFinished={isFinished}
            />
          </Box>
          <Box mb={2}>
            <LeadDetailCard
              onUpdateLeadSuccess={onUpdateLeadSuccess}
              isLoading={lead?.isLoading}
              data={lead?.data}
              isFinished={isFinished}
            />
          </Box>
        </Grid>
        <Grid item xs={12} lg={5}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={12}>
              <LeadAddressDetailCard
                onUpdateLeadSuccess={onUpdateLeadSuccess}
                isLoading={lead?.isLoading}
                data={lead?.data}
                isFinished={isFinished}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <LeadCustomerTrackingNotificationListDetailCard
                isLoading={lead?.isLoading}
                data={lead?.data}
                onUpdateLeadSuccess={onUpdateLeadSuccess}
                isFinished={isFinished}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ContentWrapper>
  )
}

export default LeadDetailPage
